import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Carousel from "react-material-ui-carousel";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import "@/components/Elements/CSS/style.css";
import readme from "@/assets/readme.svg";
import card3 from "@/assets/card3.svg";
import { url } from "inspector";
import topContainerData from "@/assets/topContainer.png";
import "../../../components/Elements/CSS/style.css";
import spinner from "@/assets/spinner.svg";
import Countdown from "react-countdown";
import mervVideo from "../../../assets/Promohomepage.webm";
import mervVideoLow from "../../../assets/PromohomepageLow.mp4";
import { useHomeScreenBannerList } from "../api/getBannerData";
import comingsoon from "@/assets/coming_soon_logo.png";
import { AdvancedVideo } from "@cloudinary/react";
import { Cloudinary } from "@cloudinary/url-gen";
import { auto } from "@cloudinary/url-gen/actions/resize";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";
import { useNavigate } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  background: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
interface topContainerProps {
  status: boolean;
  dataRecent: any;
}

export const TopContainer = ({ status, dataRecent }: topContainerProps) => {
  const cld = new Cloudinary({ cloud: { cloudName: "db8kdqi2s" } });
  const video = cld.video("docs/models");
const navigate = useNavigate();
  var result = new Date();
  var targetDate = result.setDate(result.getDate() + 2);
  const countDownDate = new Date(targetDate).getTime();
  const hidden = useMediaQuery("(min-width: 567px)");
  const bannerData = dataRecent?.homeSectionBanner?.[0];
  console.log(bannerData, "bannerData");
  const [counter, setCountDown] = useState();

  useEffect(() => {
    setCountDown(dataRecent?.upCommingLotteries[0]?.lotteryDrawDate);
  });
  var img =
    dataRecent?.upCommingLotteries[0]?.image !== undefined
      ? `${process.env.API_URL_PREFIX
      }/api/v1/admin/uploads/${dataRecent?.upCommingLotteries[0]?.image.replace(
        /\s+/g,
        "_"
      )}`
      : topContainerData;

  console.log("counter", counter);
  var cardStyle = {
    display: "block",
    transitionDuration: "0.3s",
    boxShadow: "0px 4px 50px 30px rgba(181, 181, 181, 0.05)",
    borderRadius: "20px",
  };
  var cardStyle3 = {
    display: "block",
    transitionDuration: "0.3s",
    backgroundColor: "transparent",
    height: "100%",
    backgroundRepeat: "no-repeat",
    boxShadow: "0px 4px 50px 30px rgba(181, 181, 181, 0.05)",
    borderRadius: "20px",
    backgroundSize: "cover",
  };
  var boxCard = {
    background: "#3C37FF",
    borderRadius: "8px",
    padding: "10px 25px",
    margin: "4px",
  };
  var yellowBox = {
    padding: "16px 20px 16px 20px",
    background: "rgba(255, 220, 57, 0.15)",
    borderRadius: "14.4px",
  };
  return (
    <Box
      pt={{
        xs: "10px !important",
        sm: "20px !important",
        md: "50px !important",
      }}
    >
      <Grid
        container
        display={"flex"}
        direction={"row"}
        spacing={{ xs: 1, md: 2 }}
        justifyContent={"center"}
        marginTop={{ xs: "0px", md: "30px", lg: "60px" }}
      >
        <Grid item xs={12} sm={4} md={4}>
          <Card
            style={cardStyle}
            className="backgroundsize100per"
            sx={{
              height: { xs: "280px", sm: "280px", md: "492px", xl: "650px" },
              backgroundImage: dataRecent?.firstupComRecords?.[0]
                ? `url("${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${dataRecent.firstupComRecords[0].image}")`
                : "none",
              backgroundRepeat: { xs: "no-repeat" },
              backgroundSize: {
                xs: "45% 100% !important",
                md: "100% 100% !important",
              },
              backgroundPosition: { xs: "top left", md: "center" },
              backgroundColor: !dataRecent?.firstupComRecords?.[0]
                ? "rgb(5, 5, 24)"
                : "rgba(0, 0, 0, 0.5)",
              backgroundAttachment: "scroll",
            }}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: { xs: "row", md: "column" },
                alignItems: "center",
                boxSizing: "border-box",
                padding: { xs: "10px !important", lg: "20px !important" },
                justifyContent: dataRecent?.firstupComRecords?.[0]
                  ? "flex-end"
                  : "center",
                marginTop: dataRecent?.firstupComRecords?.[0]
                  ? { xs: "0px" }
                  : "0px",
                width: dataRecent?.firstupComRecords?.[0] ? { xs: "55%", md: "100%" } : "100%",
                height: "100%",
                marginLeft: dataRecent?.firstupComRecords?.[0] ? { xs: "45%", md: "0px" } : "0px",
                background: { xs: "rgba(0, 0, 0, 1)", md: "transparent" },
              }}
            >
              {dataRecent?.firstupComRecords?.[0] ? (
                <Stack spacing={{ xs: 1, md: 2 }} width="100%">
                  <Box
                    className="top-container-card-bg"
                    sx={{
                      padding: { xs: "0px !important", md: "22px !important" },
                    }}
                  >
                    <Item sx={{ boxShadow: "none" }}>
                      <Typography
                        variant="h2"
                        sx={{
                          textTransform: "uppercase",
                          color: "white",
                          textAlign: "center",
                          fontSize: {
                            md: "22px !important",
                            sm: "18px !important",
                            xs: "16px !important",
                          },
                          fontWeight: 700,
                          lineHeight: 1.5,
                        }}
                      >
                        {dataRecent.firstupComRecords[0].lotteryName}
                      </Typography>
                    </Item>
                    <Item sx={{ boxShadow: "none" }}>
                      <Typography
                        variant="h3"
                        sx={{
                          color: "#7E7E7E",
                          fontSize: {
                            xs: "12px",
                            sm: "13px",
                            md: "16px",
                          },
                          marginBlock: {
                            xs: "8px !important",
                            md: "12px !important",
                          },
                        }}
                      >
                        Next Drawn in
                      </Typography>
                    </Item>
                    <Item sx={{ boxShadow: "none" }}>
                      <Typography
                        variant="h5"
                        align="center"
                        sx={{
                          fontSize: {
                            md: "22px !important",
                            sm: "16px !important",
                            xs: "16px !important",
                          },
                          fontWeight: "700",
                          wordBreak: "break-word",
                        }}
                      >
                        <Countdown
                          date={
                            new Date(
                              dataRecent?.firstupComRecords?.[0]
                                ?.lotteryDrawDate || Date.now()
                            )
                          }
                        />
                      </Typography>
                    </Item>
                    <Item
                      sx={{ boxShadow: "none", cursor: "pointer", mt: "10px" }}
                    >
                      <Button
                        sx={{
                          backgroundColor: "#3C37FF",
                          "&:hover": {
                            backgroundColor: "#5853f7",
                          },
                          color: "#FFFF",
                          borderRadius: "19px",
                          padding: "8px 12px",
                          fontSize: {
                            md: "14px",
                            sm: "10px",
                            xs: "12px",
                          },
                          whiteSpace: "nowrap",
                          display: "flex",
                          flexFlow: "row nowrap",
                          gap: {
                            xs: "5px",
                            md: "10px",
                          },
                          alignItems: "center",
                          "& img": {
                            width: {
                              xs: "16px",
                              sm: "12px",
                              md: "16px",
                            },
                          },
                        }}
                        onClick={() => {
                          const lotteryId = dataRecent?.firstupComRecords?.[0]?._id;
                          navigate("/auth/login", { state: { from: { pathname: `/app/Lotteries/${lotteryId}` } } });
                        }}
                      >
                        Buy Tickets <img src={readme} alt="" />
                      </Button>
                    </Item>
                  </Box>
                </Stack>
              ) : (
                <Box display="flex" justifyContent="center" alignItems="center" width={"100%"}>
                  <img
                    src="/Comp_1.gif"
                    alt="Coming Soon"
                    style={{
                      width: "auto",
                      maxWidth: "250px",
                    }}
                    loading="lazy"
                  />
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {status && (
          <Grid item xs={12} sm={4} md={4}>
            <Card
              style={cardStyle}
              sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
                backgroundColor: "#000 !important",
                height: {
                  xs: "280px !important",
                  sm: "280px !important",
                  md: "492px !important",
                  xl: "650px !important",
                },
              }}
            >
              <CardActionArea
                sx={{
                  display: "flex",
                  flexGrow: "1",
                  border: "none",
                  margin: 0,
                  padding: 0,
                  height: "100%",
                  width: "100%",
                }}
              >
                {/* <video
                  style={{
                    height: "100%",
                    width: "100%",
                    border: "none",
                    objectFit: "cover",
                  }}
                  playsInline
                  autoPlay
                  loop
                  muted
                  controls
                  src={mervVideo}
                /> */}
                <video
                  style={{
                    height: "100%",
                    width: "100%",
                    border: "none",
                    objectFit: "fill",
                  }}
                  playsInline
                  autoPlay
                  loop
                  muted
                  controls
                >
                  <source src="/videos/Promohomepage.webm" type="video/webm" />
                  <source src="/videos/PromohomepageLow.mp4" type="video/mp4" />
                </video>
              </CardActionArea>

              {/* <CardActionArea
                sx={{
                  display: 'flex',
                  flexGrow: '1',
                  border: 'none',
                  margin: 0,
                  padding: 0,
                  height: '100%',
                  width: '100%',
                }}
              >
             
                <AdvancedVideo
                  cldVid={video}
                  controls
                  autoPlay
                  loop
                  muted
                  style={{ height: '100%', width: '100%', border: 'none' }}
                />

              </CardActionArea> */}
            </Card>
          </Grid>
        )}
        <Grid item xs={12} sm={4} md={4}>
          <Carousel
            className="cstm1-crousel"
            animation="slide"
            interval={10000}
            indicatorContainerProps={{
              style: {
                color: "#FFFF",
                zIndex: 1,
                display: "flex",
                justifyContent: "center",
                fontSize: "5px",
                marginBottom: "15px",
                height: "100%",
              },
            }}
            activeIndicatorIconButtonProps={{
              style: {
                color: "#FFFFF",
                fill: "#ffff",
              },
            }}
            sx={{
              width: "100%",
              height: {
                xs: "280px !important",
                sm: "280px !important",
                md: "492px !important",
                xl: "650px !important",
              },
            }}
          >
            {bannerData?.bannerImage.map((item, i) => (
              <Box
                style={cardStyle3}
                className="backgroundsize100per"
                sx={{
                  minHeight: {
                    xs: "280px !important",
                    sm: "280px !important",
                    md: "492px !important",
                    xl: "650px !important",
                  },
                  height: "100%",
                  backgroundImage: `url("${process.env.API_URL_PREFIX}/api/v1/admin/uploads/${item}")`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundColor: "#000 !important",
                }}
              ></Box>
            ))}
          </Carousel>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TopContainer;
